export type AcquisitionEventName =
  | 'homepage_view' | 'need_service_click' | 'provide_services_click'
  | 'contractor_page_view' | 'contractor_signup_start' | 'contractor_signup_complete'
  | 'customer_request_start' | 'customer_request_complete'
  | 'property_manager_page_view' | 'founding_provider_interest'
  | 'signup_abandonment_step'

type AcquisitionProperties = Record<string, string | number | boolean | null>

const forbiddenProperty = /email|phone|name|address|description|message|content/i

export function trackAcquisitionEvent(event: AcquisitionEventName, properties: AcquisitionProperties = {}) {
  const safeProperties = Object.fromEntries(Object.entries(properties).filter(([key]) => !forbiddenProperty.test(key)))
  const detail = { event, properties: safeProperties, occurred_at: new Date().toISOString() }
  window.dispatchEvent(new CustomEvent('propertyready:acquisition', { detail }))
  if (import.meta.env.DEV) console.info('[acquisition]', detail)
}

export const acquisitionFunnelMetrics = [
  'Visitor → provider CTA', 'Provider CTA → signup', 'Signup → profile creation',
  'Profile → onboarding start', 'Onboarding → compliance submission', 'Compliance → eligibility',
  'Eligible provider → first opportunity', 'Opportunity → first offer', 'Offer → first completed job',
] as const
